import { connect } from 'react-redux';

import AllProductsPage from './AllProductsPage';

export default connect(null)(AllProductsPage);
